module.exports = __webpack_public_path__ + "2ed0dd2c141e966dc837324c30d169be.png";